/**
 * @Author: shenyi
 * @Date:   2023-08-13 12:56:37
 * @Last Modified by:   shenyi
 * @Last Modified time: 2023-08-13 13:23:34
 */
import axios from "axios";
import { message, notification } from "antd";
import { MessageType } from "antd/lib/message";
import Cookies from "js-cookie";
import { isInBxApp } from "../utils";

const addErrorLog = (errorInfo: any) => {
  // const {
  //   statusText,
  //   status,
  //   request: { responseURL }
  // } = errorInfo;
  // let info = {
  //   type: "ajax",
  //   code: status,
  //   mes: statusText,
  //   url: responseURL
  // };
};
class HttpRequest {
  public baseUrl: string;
  public token: string = "";
  public loadings: MessageType[] = [];
  public queue: any;
  constructor(baseUrl: string, groupId?: string) {
    this.baseUrl = baseUrl;
    this.queue = {};
    axios.defaults.headers.token = Cookies.get("token") || "";
    if (groupId) {
      axios.defaults.headers.groupId = groupId;
    }
  }
  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      methods: "get",
      crossDomain: true,
      withCredentials: false,
      headers: {
        //
        "Content-Type": "application/json;charset=utf-8",
      },
    };
    return config;
  }
  setToken(token: string) {
    this.token = token || "";
    Cookies.set("token", token || "");
    axios.defaults.headers.token = token || "";
  }
  destroy(url: string) {
    delete this.queue[url];
    // if (!Object.keys(this.queue).length) {
    //   for(let loading of this.loadings){
    //     loading();
    //   }
    // }
  }
  interceptors(
    instance: any,
    url: string,
    noLoading = false,
    noMessage = false
  ) {
    // 请求拦截
    instance.interceptors.request.use(
      (config: any) => {
        // 添加全局的loading...
        //if (!Object.keys(this.queue).length) {
        // if (!noLoading) {
        //   this.loadings.push(message.loading("加载中……", 0));
        // }
        //}
        this.queue[url] = true;
        return config;
      },
      (error: any) => {
        return Promise.reject(error);
      }
    );
    // 响应拦截
    instance.interceptors.response.use(
      (res: any) => {
        this.destroy(url);
        const { data } = res;
        let { code = "500", msg = "未知异常" } = data;
        if (res.status === 200 && !res.data.code) {
          code = "1000000";
        }
        switch (true) {
          case code === "9000001" || code === "9000004": {
            if (isInBxApp) {
              window.BXBridge.logoutApp();
            } else {
              notification.destroy();
              let args = {
                message: "提示",
                description: "用户已超时即将重新登录！",
                duration: 3,
                onClose: () => {
                  window.location.replace(
                    `/fe-pc/fe_newlogin/login?fromUrl=${window.location.href}`
                  );
                },
              };
              !noMessage && notification.warning(args);
            }
            return Promise.reject({ code, message: msg });
          }
          case code === "9000002": {
            notification.destroy();
            let args = {
              message: "提示",
              description: data.msg,
              duration: 3,
            };
            !noMessage && notification.warning(args);
            return Promise.reject({ code, message: msg });
          }
          case code === "1000000" || status === "ok": {
            return data;
          }
          case !["9000001", "9000002", "9000004"].some(
            (item) => item === code
          ): {
            notification.destroy();
            let args = {
              message: "提示",
              description: data.msg,
              duration: 3,
            };
            !noMessage && notification.warning(args);
            return Promise.reject({ code, message: msg });
          }
          default: {
            if (!data.code) {
              return res;
            }
            return code !== "1000000"
              ? Promise.reject({ code, message: msg })
              : res;
          }
        }
      },
      (error: any) => {
        this.destroy(url);
        if (error.response) {
          let errorInfo = error.response;
          if (!errorInfo) {
            const {
              request: { statusText, status },
              config,
            } = JSON.parse(JSON.stringify(error));
            errorInfo = {
              statusText,
              status,
              request: { responseURL: config.url },
            };
          }
          addErrorLog(errorInfo);
        } else {
          notification.warning({
            message: "提示",
            description: JSON.stringify(error),
          });
        }

        return Promise.reject(error);
      }
    );
  }
  // jsonp(url) {
  //   if (!url) {
  //     throw new Error("url is necessary");
  //   }
  //   const callback = "BxJsonpCallback";
  //   const JSONP = document.createElement("script");
  //   JSONP.setAttribute("type", "text/javascript");
  //   const headEle = document.getElementsByTagName("head")[0];
  //   JSONP.src = url;
  //   const remove=()=> {
  //     headEle.removeChild(JSONP);
  //     delete window[callback];
  //   }
  //   return new Promise<any>((resolve, reject) => {
  //     if(!window[callback]){
  //       window[callback] = (r) => {
  //         sessionStorage.setItem("feConfig",JSON.stringify(r))
  //         resolve(r);
  //         remove();
  //       };
  //       // console.log(JSONP)
  //       JSONP.onerror = function () {
  //         reject();
  //         remove();
  //       };
  //       headEle.appendChild(JSONP);
  //     }else{
  //       resolve(JSON.parse(sessionStorage.getItem("feConfig")))
  //     }
  //   });
  // }
  // getApiHost(){
  //   return new Promise(async (resolve,reject)=>{
  //     if(!HttpRequest.jsonpLock){
  //       HttpRequest.jsonpLock=true
  //       const configUrl=process.env.NODE_ENV != 'development' ?
  //         `${window.location.origin}/fe-config.js?version=${new Date().getTime()}`
  //         :`https://test.dbxiao.cn/fe-config.js?version=${new Date().getTime()}`
  //       const { apiHost } = await this.jsonp(configUrl);
  //       HttpRequest.apiHost=`https://${apiHost}`
  //       this.baseUrl=HttpRequest.apiHost
  //       resolve(HttpRequest.apiHost)
  //     }else if(HttpRequest.apiHost){
  //       this.baseUrl=HttpRequest.apiHost
  //       resolve(HttpRequest.apiHost)
  //     }
  //   })
  // }
  async request(options: any) {
    if (!sessionStorage.getItem("feConfig")) {
      const { data: config } = await axios.request({
        url: `${
          window.location.origin
        }/fe-config.json?version=${new Date().getTime()}`,
        method: "get",
      });
      sessionStorage.setItem("feConfig", JSON.stringify(config));
    }
    const instance = axios.create();
    const { apiHost } = JSON.parse(sessionStorage.getItem("feConfig"));
    this.baseUrl = `https://${apiHost}`;
    options = Object.assign(this.getInsideConfig(), options);

    this.interceptors(
      instance,
      options.url,
      options.noLoading,
      options.noMessage
    );
    return instance(options);
  }
}
export default HttpRequest;
